import React, { Component, Children, cloneElement } from 'react';
import { isHeaderCell } from './Cell';
import Header from './Header';

const [ASC, DESC] = ['asc', 'desc'];
const INVERSE_DIRECTIONS = { [ASC]: DESC, [DESC]: ASC };

/**
 * @todo Make this controlled via props as well
 * @todo Write tests
 */
class SortableHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      column:
        props.sortBy === undefined
          ? props.children[0].props.name
          : props.sortBy,
      direction: props.direction,
    };
  }

  static defaultProps = {
    direction: ASC,
    onSort: () => {},
  };

  get reverseDirection() {
    return INVERSE_DIRECTIONS[this.state.direction];
  }

  handleSort(column) {
    this.setState(
      state => ({
        column,
        direction: column === state.column ? this.reverseDirection : ASC,
      }),
      () => this.props.onSort(this.state),
    );
  }

  renderChildren() {
    return Children.map(this.props.children, (child, index) => {
      if (!isHeaderCell(child)) return child;
      return cloneElement(child, {
        onClick: () => this.handleSort(child.props.name),
        clickable: true,
        sort:
          this.state.column === child.props.name
            ? this.state.direction
            : undefined,
      });
    });
  }

  render() {
    const { onSort, sortBy, direction, ...props } = this.props;
    return <Header {...props} children={this.renderChildren()} />;
  }
}

export default SortableHeader;
